<template>
  <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="form" label-width="100px">
    <el-form-item :label="$t('workbench.selectModel.billingType')" prop="billingValue">
      <el-button
        v-for="item in billingTypeData"
        :key="item.InstanceChargeType"
        :type="item.InstanceChargeType === ruleForm.billingValue?'primary':null"
        @click="billingClick(item)"
      >
        {{ item.name }}
      </el-button>
    </el-form-item>

    <el-form-item :label="$t('workbench.selectModel.machineConfig')" required>
      <el-col :span="8" class="base-margin__right-5">
        <el-form-item prop="model">
          <p>{{ $t('workbench.selectModel.instanceType') }}</p>
          <el-select
            v-model="ruleForm.model"
            :placeholder="$t('workbench.selectModel.selectInstanceType')"
            clearable
            @change="(value) => {selectHandler(value, 'type')}"
          >
            <el-option
              v-for="item in instanceTypeOption"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8" class="base-margin__right-5">
        <el-form-item prop="config">
          <p>{{ $t('workbench.selectModel.configuration') }}</p>
          <el-select
            v-model="ruleForm.config"
            :placeholder="$t('workbench.selectModel.selectConfiguration')"
            clearable
            @change="(value) => {selectHandler(value, 'description')}"
          >
            <el-option
              v-for="item in instanceDescriptionOption"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <p class="base-white-space__normal">{{ $t('workbench.selectModel.configurationCost') }}</p>
        <el-button type="text">
          {{
            ruleForm.price === '' ? $t('workbench.selectModel.zeroYuanPerHour') : `${ruleForm.price} ${$t('workbench.selectModel.yuanPerHour')}`
          }}
        </el-button>
      </el-col>
    </el-form-item>

    <el-form-item :label="$t('workbench.selectModel.diskSelection')" prop="diskSize">
      <el-select
        v-model="ruleForm.diskSize"
        :placeholder="$t('workbench.selectModel.selectDiskSize')"
        disabled
      >
        <el-option
          v-for="item in diskOption"
          :key="item.value"
          :label="item.text"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="run">{{ $t('workbench.selectModel.create') }}</el-button>
      <el-button @click="closeDialog">{{ $t('workbench.selectModel.cancel') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import axios from 'axios';
import {defaultFilterRegion} from '@/common/utils/utils';

export default {
  name: 'selectModel',

  data() {
    return {
      rules: {
        billingValue: [{required: true}],
        config: [{required: true, message: this.$t('workbench.selectModel.selectConfigurationRequired')}],
        model: [{required: true, message: this.$t('workbench.selectModel.selectInstanceTypeRequired')}],
        diskSize: [{required: true, message: this.$t('workbench.selectModel.selectDiskSizeRequired')}],
      },
      ruleForm: {
        billingValue: 'POSTPAID_BY_HOUR',
        config: '',
        model: '',
        price: '',
        zone: '',
        diskSize: 100,
      },
      billingTypeData: [
        {
          InstanceChargeType: 'POSTPAID_BY_HOUR',
          name: this.$t('workbench.selectModel.payAsYouGo'),
        },
        {
          InstanceChargeType: 'SPOTPAID',
          name: this.$t('workbench.selectModel.spotInstance'),
        },
      ],
      instanceTypeOption: [],
      instanceDescriptionOption: [],
      allCvmsData: [],
      fullscreenLoading: null,
      diskOption: [
        {text: '50GB', value: 50},
        {text: '100GB', value: 100},
      ],
    };
  },

  methods: {
    billingClick(item) {
      this.ruleForm.billingValue = item.InstanceChargeType;
      this.selectInstanceChargeType(item.InstanceChargeType);
    },

    selectHandler(value, type) {
      let cvmsDataMap;
      if (this.ruleForm.billingValue === 'POSTPAID_BY_HOUR') {
        [cvmsDataMap] = this.allCvmsData;
      }
      if (this.ruleForm.billingValue === 'SPOTPAID') {
        [, cvmsDataMap] = this.allCvmsData;
      }
      // 2、服务器机型选择
      if (type === 'type' && value) {
        const instanceDescriptionList = [];
        // 构造服务器配置选项的选择内容
        cvmsDataMap.get(value).forEach((cvm) => {
          // 填充描述信息
          let description;
          description = `${cvm.Cpu}${this.$t('workbench.selectModel.core')}${cvm.Memory}${this.$t('workbench.selectModel.gb')}`;
          if (cvm.Gpu > 0) {
            description += `，${cvm.Gpu}${this.$t('workbench.selectModel.gpuUnit')}${cvm.InstanceFamily} GPU`;
          }
          const descriptionOption = {
            value: cvm.InstanceType,
            text: description,
          };
          instanceDescriptionList.push(descriptionOption);
        });
        this.ruleForm.config = ''; // 已选的配置清空
        this.ruleForm.model = value;
        this.ruleForm.price = '';
        this.instanceDescriptionOption = instanceDescriptionList;
      }

      // 3、服务器配置选择
      if (type === 'description' && value) {
        // 获取description值
        // this.instanceDescriptionOption.forEach((description) => {
        //   if (description.value === value) {
        //     state.runParams.instance.description = description.text;
        //   }
        // });

        const cvmsDataList = cvmsDataMap.get(this.ruleForm.model);
        let cvmInfo;
        if (cvmsDataList) {
          cvmsDataList.forEach((cvmData) => {
            if (cvmData.InstanceType === value) {
              cvmInfo = cvmData;
            }
          });
        }

        if (cvmInfo) {
          this.ruleForm.config = value;
          this.ruleForm.price = cvmInfo.Price.UnitPriceDiscount;
          this.ruleForm.zone = cvmInfo.Zone;
        }
      }
    },

    async run() {
      await this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          try {
            this.fullscreenLoading = this.$loading({
              lock: true,
              text: this.$t('workbench.selectModel.initializing'),
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)',
            });

            const res = await axios({
              method: 'post',
              url: '/api/eda/common/project/createProject',
              headers: {
                'Content-Type': 'application/json',
              },
              data: {
                region: this.region,
                zone: this.ruleForm.zone,
                instanceType: this.ruleForm.config,
                instanceChargeType: this.ruleForm.billingValue,
                renewFlag: 'NOTIFY_AND_MANUAL_RENEW',
                diskSize: this.ruleForm.diskSize,
                period: 1,
                imageId: 'img-jl7s30kk',
              },
            });
            this.fullscreenLoading.close();
            if (res.data.code > 0) {
              this.$message(res.data.data);
              return false;
            }
            this.$message(this.$t('workbench.selectModel.projectCreatedSuccess'));
            this.envInfo = res.data.Data || {};
            // 如果是失败状态，提示
            if (+this.envInfo.Status === 2) {
              this.$message(this.envInfo.ErrMsg);
            }
            this.$router.push({name: 'dashboard'});
            // setTimeout(() => {
            //   this.updateEnv();
            // }, 1000);
          } catch (e) {
            this.$message(this.$t('workbench.selectModel.initializationFailed'));
            this.fullscreenLoading.close();
          }
          this.$emit('close');
        } else {
          return false;
        }
      });
    },

    getInstance(res) {
      const cvmMapPostpaidByHour = new Map();
      const cvmMapSpotpaid = new Map();

      // 根据机型去重
      const cvmNonredundantPostpaidByHourMap = new Map();
      const cvmNonredundantSpotpaidMap = new Map();
      res.forEach((cvm) => {
        if (cvm.Status === 'SELL' && cvm.InstanceChargeType === 'POSTPAID_BY_HOUR') {
          cvmNonredundantPostpaidByHourMap.set(cvm.InstanceType, cvm);
        }
        if (cvm.Status === 'SELL' && cvm.InstanceChargeType === 'SPOTPAID') {
          cvmNonredundantSpotpaidMap.set(cvm.InstanceType, cvm);
        }
      });
      // 构造按量计费结构
      for (const cvm of cvmNonredundantPostpaidByHourMap.values()) {
        if (cvmMapPostpaidByHour.has(cvm.TypeName)) {
          cvmMapPostpaidByHour.get(cvm.TypeName).push(cvm);
        } else {
          cvmMapPostpaidByHour.set(cvm.TypeName, [cvm]);
        }
      }

      // 构造竞价实例结构
      for (const cvm of cvmNonredundantSpotpaidMap.values()) {
        if (cvmMapSpotpaid.has(cvm.TypeName)) {
          cvmMapSpotpaid.get(cvm.TypeName).push(cvm);
        } else {
          cvmMapSpotpaid.set(cvm.TypeName, [cvm]);
        }
      }
      this.allCvmsData = [cvmMapPostpaidByHour, cvmMapSpotpaid];
      this.selectInstanceChargeType(this.ruleForm.billingValue);
    },
    /**
     * 选择实例
     * @param {*} type
     * @return {*}
     */
    selectInstanceChargeType(type) {
      const instanceTypeList = [];
      this.instanceTypeOption = [];
      this.instanceDescriptionOption = [];
      this.ruleForm.model = '';
      this.ruleForm.config = '';
      this.ruleForm.price = '';
      this.ruleForm.zone = '';
      this.ruleForm.diskSize = 100;

      let cvmsDataMap;
      if (type === 'POSTPAID_BY_HOUR') {
        [cvmsDataMap] = this.allCvmsData;
      }
      if (type === 'SPOTPAID') {
        [, cvmsDataMap] = this.allCvmsData;
      }

      // 3、构造服务器机型选项的选择内容
      if (cvmsDataMap) {
        for (const key of cvmsDataMap.keys()) {
          const typeOption = {
            value: key,
            text: key,
          };
          instanceTypeList.push(typeOption);
        }
      }
      this.instanceTypeOption = instanceTypeList;
    },
    /**
     * 关闭弹窗
     */
    close() {
      this.ruleForm = {
        billingValue: 'POSTPAID_BY_HOUR',
        config: '',
        model: '',
        price: '',
        zone: '',
        diskSize: 50,
      };
      this.instanceDescriptionOption = [];
      this.instanceTypeOption = [];
    },
    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.$emit('close');
    },
  },

  computed: {
    region() {
      const index = this.ruleForm.zone.lastIndexOf('-');
      return this.ruleForm.zone.slice(0, index);
    },
  },

  async mounted() {
    const res = await axios({
      method: 'post',
      url: '/api/eda/common/eda/getInstanceList',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        projectId: 7,
        region: defaultFilterRegion(),
      },
    });
    this.getInstance(res.data.data.InstanceList);
  },
};
</script>
